import { useContext } from 'react'

import { ConsultationContext, ConsultationContextProps } from '@/contexts/consultation'
import { Consultation, CONSULTATION_STATUS } from '@/types/consultation'

const MAX_FOLLOW_UP_QUESTIONS = 3

interface UseConsultationProps {
  consultation: ConsultationContextProps['consultation']
  updateConsultation: (consultation: Consultation) => void
  isFollowUp: boolean
  canDoFollowUp: boolean
}

export const useConsultation = (): UseConsultationProps => {
  const { consultation, setConsultation } = useContext(ConsultationContext)

  const updateConsultation = (consultation: Consultation) => {
    setConsultation(consultation)
  }

  const canDoFollowUp = Boolean(!consultation?.questions || consultation?.questions?.length < MAX_FOLLOW_UP_QUESTIONS)

  const isFollowUp = Boolean(consultation?.status === CONSULTATION_STATUS.RESOLVED && consultation?.questions?.length)

  return {
    consultation,
    updateConsultation,
    isFollowUp,
    canDoFollowUp
  }
}
